import { ProjectsApi } from '../apis';
import { Project, ProjectType } from '../types';

type ProjectCache = { [projectType in ProjectType]: Project[] | undefined };

const projectCache = {} as ProjectCache;

export const getProjects = async (
  type: ProjectType,
  searchPhrase?: string
): Promise<Project[]> => {
  if (type === 'searched' && searchPhrase) {
    searchPhrase = escape(searchPhrase.split("'").join("''"));
    return ProjectsApi.fetchProjects(type, searchPhrase);
  }

  const cachedProjects = projectCache[type];
  if (cachedProjects) return cachedProjects;

  const projects = await ProjectsApi.fetchProjects(type);
  projectCache[type] = projects;
  return projects;
};
